<template src="./index.html"></template>
<style lang="scss" scoped src="./index.scss"></style>
<script>
import { Toast, Popup  } from 'vant';
import { URL4 } from "@/utils/Redirect";
import * as echarts from 'echarts'
export default {
    data() {
        return {
            contentShow: false,
            lostShow: false,
            dataList:[
                '3分钟旺旺响应率',
                '慢响应分析',
                '平均响应时间分析',
                '漏跟进分析',
                '客服违规词分析',
                '客户流失分析',
                '新客户询盘分析',
                '老客户询盘分析',
                '客服销售业绩分析',
                '客服询盘转化率分析',
            ],
            authorization: false,
            popupShow: false,
            editionShow: 'wxt',
            pBtnActive: 0,
            pTimeActive: 0,
            dataShowList: [
                {name: '询单提醒消息', color:'#FF9F2D', num: ''},
                {name: '售后提醒消息', color:'#FFE500', num: ''},
                {name: '发货提醒消息', color:'#EF50A7', num: ''},
                {name: '订单提醒消息', color:'#8DB1FF', num: '即将上线'},
                ],
            stroeArr: [],
            stroeActive: 0,
            chooseStroeActive: 0,
            choose_stroe_popup: false,
            pieData: [],
            testNum: '99.44', 
            userData: {},
        }
    },
    components:{
        Popup,
        Toast,
    },
    mounted() {
        this.getData()
        
    },
    methods: {
        getData(getDataType) {
            let source = localStorage.getItem('source')
            let date_type
            if(this.pTimeActive == 0) {
                date_type = 'yesterday'
            }
            if(this.pTimeActive == 1) {
                date_type = 'today'
            }
            if(this.pTimeActive == 2) {
                date_type = 'curr_month'
            }
            this.$store.dispatch("ServiceResponse/Diagnostic",{source, date_type}).then((res) => {
                if(res.code == 1000) {
                    this.userData = res.data
                    for(let i in res.data.visitor_info) {
                        res.data.visitor_info[i].start_date = `${res.data.visitor_info[i].start_date.split("-")[0]}年${res.data.visitor_info[i].start_date.split("-")[1]}月${res.data.visitor_info[i].start_date.split("-")[2]}日`
                        res.data.visitor_info[i].end_date = `${res.data.visitor_info[i].end_date.split("-")[0]}年${res.data.visitor_info[i].end_date.split("-")[1]}月${res.data.visitor_info[i].end_date.split("-")[2]}日`
                    }
                    this.stroeArr = res.data.visitor_info

                    this.pieData = [this.stroeArr[this.stroeActive].inquiry_remind_num, this.stroeArr[this.stroeActive].after_remind_num, this.stroeArr[this.stroeActive].fahuo_remind_num]
                    this.dataShowList[0].num = this.stroeArr[this.stroeActive].inquiry_remind_num
                    this.dataShowList[1].num = this.stroeArr[this.stroeActive].after_remind_num
                    this.dataShowList[2].num = this.stroeArr[this.stroeActive].fahuo_remind_num

                    // this.userData.ver = "wxt"
                    if(!getDataType) {
                        this.pBtnActive = this.userData.ver == "radar" ?1 :0
                        this.editionShow = this.userData.ver
                        
                        let param = {
                            btn_name: this.editionShow == 'wxt' ?"服务响应诊断旺信通版" :'服务响应诊断绩效雷达版',
                        }
                        if(this.editionShow == 'wxt') {
                            param.vid = this.stroeArr[this.stroeActive].visitor_id
                        }
                        this.$store.dispatch("Public/inH5Record", param);
                    }
                    
                    
                    this.authorization = this.userData.has_order_new==1 ?true :false
                    
                    this.contentShow = true
                    this.lostShow = false
                    if(this.editionShow == "wxt" || this.editionShow == "wxt_no_switch") {
                        setTimeout(()=> {
                            this.myEcharts()
                        },0)
                    }
                }else if(res.code == 4016) {
                    this.contentShow = false
                    this.lostShow = true
                }else {
                    Toast("请求错误")
                }
            })
        },
        colsePopup() {
            this.popupShow = false
        },
        authorizationBtn() {
            window.location.href= URL4
        },
        loginBtn() {
            if(!this.authorization) {
                this.popupShow = true
            }else {
                Toast("请在电脑端—1688服务市场—我购买的服务—找到【绩效雷达使用】")
            }
        },
        changeHandle(index) {
            this.pBtnActive = index
            this.editionShow = index==0 ?'wxt' :'radar'
            // this.editionShow
            setTimeout(()=> {
                if(index == 0) {
                    this.myEcharts()
                }
            },0)
            let param = {
                btn_name: index==0 ?"服务响应诊断旺信通版" :'服务响应诊断绩效雷达版',
            }
            if(index == 0) {
                param.vid = this.stroeArr[this.stroeActive].visitor_id
            }
            this.$store.dispatch("Public/inH5Record", param);
        },
        changeTimeBtn(index) {
            this.pTimeActive = index
            this.getData(true)
        },
        chooseStroe() {
            if(this.stroeArr.length == 1) {
                Toast('当前仅绑定一个店铺')
            }else {
                this.choose_stroe_popup = true
            }
        },
        changeStroe(index) {
            this.chooseStroeActive = index
        },
        noneStroe() {
            this.choose_stroe_popup = false
            this.chooseStroeActive = this.stroeActive
        },
        stroeDetermineBtn() {
            this.stroeActive = this.chooseStroeActive
            this.choose_stroe_popup = false
            this.stroeName = this.stroeArr[this.stroeActive].visitor_nick
            
            this.dataShowList[0].num = this.stroeArr[this.stroeActive].inquiry_remind_num
            this.dataShowList[1].num = this.stroeArr[this.stroeActive].after_remind_num
            this.dataShowList[2].num = this.stroeArr[this.stroeActive].fahuo_remind_num
            this.pieData = [this.stroeArr[this.stroeActive].inquiry_remind_num, this.stroeArr[this.stroeActive].after_remind_num, this.stroeArr[this.stroeActive].fahuo_remind_num]
            this.myEcharts()
        },
        




        // 饼图
        myEcharts() {
            this.chart = echarts.init(document.getElementById('charts'))

            this.chart.setOption({
                grid:{
                    containLabel: true,
                },
                title:{
                    text:'提醒消息类型占比',
                    textStyle:{
                        fontSize: '15', 
                        color: '#000',
                        fontWeight: '500', 
                    },
                    // textAlign:'center',
                    right: 'center',
                    top: '1',
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: "{b} {c}条\n\n",
                },
                legend: {
                    show:false,
                },
                color: ['#FF9F2D', '#FFE500', '#EF50A7'],
                series: [
                    {
                        // name: '访问来源',
                        type: 'pie',
                        minAngle:'18',
                        radius: ['65%', '100%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true,
                                position: 'outer',
                                formatter: "{d}%\n\n",
                                borderWidth: 20,
                                borderRadius: 4,
                                padding: [0, -30],
                                color: "#3D3D3D"
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '',
                                }
                            },
                        },
                        //牵引线条颜色
                        labelLine: {
                            normal: {
                                show: true,
                                length: 20,
                                length2: 30,
                                lineStyle: {
                                    color: '#DADADA'
                                },
                            }
                        },
                        data: this.pieData,
                        top: 60,
                        bottom: 20
                    }

                ],
                media: [
                    {
                        query: {
                            minWidth: 600               // 当容器宽度大于 600 时。
                        },
                        option: {
                            title:{
                                text:'提醒消息类型占比',
                                textStyle:{
                                    fontSize: '50', 
                                    color: '#000',
                                    fontWeight: '500', 
                                },
                                right: 'center',
                                top: '0',
                            },
                            legend: {
                                right: 10,              // legend 放置在右侧中间。
                                top: '15%',
                                orient: 'vertical'      // 纵向布局。
                            },
                            series: [                   // 两个饼图上下布局。
                                {
                                    radius: ['55%', '90%'],
                                    //牵引线条颜色
                                    labelLine: {
                                        normal: {
                                            show: true,
                                            length: 60,
                                            length2: 60,
                                            lineStyle: {
                                                color: '#DADADA',
                                            },
                                        }
                                    },
                                    label: {
                                        normal: {
                                            show: true,
                                            position: 'outer',
                                            formatter: "{d}%\n\n",
                                            borderWidth: 20,
                                            borderRadius: 4,
                                            padding: [0, -30],
                                            color: "#3D3D3D",
                                            fontSize: 25,
                                        },
                                        emphasis: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '',
                                            }
                                        },
                                    },
                                },
                            ]
                        }
                    },
                    
                ]
            })
        },
    }
}
</script>



